import React from 'react';
import fr from 'facet-rest';
import {
  FDStack,
  FDEmptyState,
  FDTitleText,
  FDPaper,
  FDSecondaryActionButton,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { AccordionCategoryList } from 'Components/ComponentLibrary/Organisms/AccordionCategoryList';
import { CashFlowItem } from 'Views/Page/Content/Templates/CashFlowPageTemplate/CashFlowItem';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const JobsSectionLayout = () => {
  const { resource } = useMetaLayoutContext();

  const { loadModalCollectionByLink } = useModalContext();

  const sectionsColl = resource
    .attr('sections')
    .resources()
    .list();

  if (sectionsColl.length === 0) {
    return <FDEmptyState title="No Jobs" icon="search" />;
  }

  const handleEditCategoryClick = (rel) => () => {
    loadModalCollectionByLink(rel.link('related').url());
  };

  const onEditItemClick = (rel) => loadModalCollectionByLink(rel.link('related').url());

  return (
    <FDStack direction="column" spacing={2}>
      {sectionsColl.map(res => (
        <FDPaper key={res.id()} appearance="outlined" padding={2}>
          <FDStack direction="column" spacing={1}>
            <FDStack justifyContent={'space-between'}>
              <FDTitleText size="lg" value={res.attr('sectionName')} />
              <FDTitleText size="lg" value={res.attr('total')} data-test={`${res.attr('sectionName')}-total`} />
            </FDStack>

            <AccordionCategoryList
              categoriesCollection={res.attr('categories')}
              onEditCategoryClick={handleEditCategoryClick}
              onEditLineItemClick={onEditItemClick}
              ListItemComponent={CashFlowItem}
              emptyTitle={'No jobs for this member'}
              emptyDescription={'Add one to populate this list'}
            />

            {res.withRelationship(fr.relationships.addIncome.name,
              (rel) => (
                <FDSecondaryActionButton
                  label="Add Income"
                  icon="add"
                  onClick={() => {
                    loadModalCollectionByLink(rel.link('related').url());
                  }}
                />
              ),
              () => null)}
          </FDStack>
        </FDPaper>
      ))}
    </FDStack>
  );
};

export default JobsSectionLayout;
